import { axiosInstance as axios } from 'src/boot/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    MntNewsList({ commit, rootGetters }, request) {
      return axios
        .post('MntNewsList', request)
        .then((response) => {
          if (response.data.RC === '') {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.RC)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    MntNewsRead({ commit, rootGetters }, request) {
      return axios
        .post('MntNewsRead', {
          ...request
        })
        .then((response) => {
          if (response.data.RC === '') {
            if (response.data.Values.ReqInt === 0) {
              return Promise.resolve(response.data.Values)
            } else {
              return Promise.reject('訊息公告讀取失敗')
            }
          } else {
            return Promise.reject(response.data.RC)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    MntNewsUpload({ commit, rootGetters }, request) {
      let formData = new FormData()
      formData.append('NewsDate', request.NewsDate)
      formData.append('NewsType', request.NewsType)
      formData.append('NewsTitle', request.NewsTitle)
      formData.append('NewsSubTitle', request.NewsSubTitle)

      request.NewsImageFile.forEach((file) => {
        formData.append('NewsImageFile', file)
      })

      formData.append('NewsContent', request.NewsContent)

      return axios
        .post('MntNewsUpload', formData)
        .then((response) => {
          if (response.data.Values) {
            if (response.data.Values.ReqInt === 0) {
              return Promise.resolve('訊息公告新增成功！')
            } else {
              return Promise.reject('訊息公告新增失敗')
            }
          } else {
            return Promise.reject(response.data.RC)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    MntNewsModify({ commit, rootGetters }, request) {
      let formData = new FormData()
      formData.append('NewsGuid', request.NewsGuid)
      formData.append('NewsDate', request.NewsDate)
      formData.append('NewsType', request.NewsType)
      formData.append('NewsTitle', request.NewsTitle)
      formData.append('NewsSubTitle', request.NewsSubTitle)

      request.NewsImageFile.forEach((file) => {
        formData.append('NewsImageFile', file)
      })

      formData.append('NewsContent', request.NewsContent)

      return axios
        .post('MntNewsModify', formData)
        .then((response) => {
          if (response.data.Values) {
            if (response.data.Values.ReqInt === 0) {
              return Promise.resolve('訊息公告修改成功！')
            } else {
              return Promise.reject('訊息公告修改失敗')
            }
          } else {
            return Promise.reject(response.data.RC)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    /**
     *
     * @param commit
     * @param rootGetters
     * @param request 1 => 下架 2 => 公開  9 => 刪除
     * @returns {Q.Promise<never>}
     * @constructor
     */
    MntChangeNewsStatus({ commit, rootGetters }, request) {
      return axios
        .post('MntChangeNewsStatus', {
          NewsGuid: request.NewsGuid,
          NewsStatus: request.NewsStatus
        })
        .then((response) => {
          if (response.data.Values) {
            if (response.data.Values.ReqInt === 0) {
              return Promise.resolve()
            } else if (response.data.RC) {
              return Promise.reject(response.data.RC)
            }
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    MntChangeCaseStatus({ commit, rootGetters }, request) {
      return axios
        .post('MntChangeCaseStatus', {
          CaseGuid: request.CaseGuid,
          CaseStatus: request.CaseStatus
        })
        .then((response) => {
          if (response.data.Values) {
            if (response.data.Values.ReqInt === 0) {
              return Promise.resolve()
            } else if (response.data.RC) {
              return Promise.reject(response.data.RC)
            }
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    MntCaseList({ commit, rootGetters }, request) {
      return axios
        .post('MntCaseList', request)
        .then((response) => {
          if (response.data.RC === '') {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.RC)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    MntCaseRead({ commit, rootGetters }, request) {
      return axios
        .post('MntCaseRead', {
          CaseGuid: request.CaseGuid
        })
        .then((response) => {
          if (response.data.RC === '') {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.RC)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    MntCaseBlockRemove({ commit, rootGetters }, request) {
      return axios
        .post('MntCaseBlockRemove', {
          BlockGuid: request.BlockGuid
        })
        .then((response) => {
          if (response.data.Values) {
            if (response.data.Values.ReqInt === 0) {
              return Promise.resolve('刪除成功！')
            } else {
              return Promise.reject('刪除失敗')
            }
          } else {
            return Promise.reject(response.data.RC)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    MntCaseModify({ commit, rootGetters }, request) {
      return axios
        .post('MntCaseModify', {
          CaseGuid: request.CaseGuid,
          CaseTitle: request.CaseTitle,
          CaseRemark: request.CaseRemark,
          CaseStyles: request.CaseStyles
        })
        .then((response) => {
          if (response.data.Values) {
            if (response.data.Values.ReqInt === 0) {
              return Promise.resolve('修改成功！')
            } else {
              return Promise.reject('修改失敗！')
            }
          } else {
            return Promise.reject(response.data.RC)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    MntCaseBlockAdd({ commit, rootGetters }, request) {
      let formData = new FormData()
      formData.append('CaseGuid', request.CaseGuid)
      formData.append('BlockType', request.BlockType)
      formData.append('BlockTitle', request.BlockTitle)
      request.ImageFiles.forEach((imageFile) => {
        formData.append('ImageFiles', imageFile)
      })

      return axios
        .post('MntCaseBlockAdd', formData)
        .then((response) => {
          if (response.data.Values) {
            if (response.data.Values.ReqInt === 0) {
              return Promise.resolve('新增成功！')
            } else {
              return Promise.reject('新增失敗！')
            }
          } else {
            return Promise.reject(response.data.RC)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    MntCaseBlockModify({ commit, rootGetters }, request) {
      let formData = new FormData()
      formData.append('BlockGuid', request.BlockGuid)
      formData.append('BlockTitle', request.BlockTitle)

      request.BlockAddImage.forEach((image) => {
        formData.append('BlockAddImage', image)
      })

      request.BlockRemoveImage.forEach((image) => {
        formData.append('BlockRemoveImage', image)
      })

      return axios
        .post('MntCaseBlockModify', formData)
        .then((response) => {
          if (response.data.Values) {
            if (response.data.Values.ReqInt === 0) {
              return Promise.resolve('修改成功！')
            } else {
              return Promise.reject('修改失敗！')
            }
          } else {
            return Promise.reject(response.data.RC)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    MntCaseUpload({ commit, rootGetters }, request) {
      let formData = new FormData()
      formData.append('CaseTitle', request.CaseTitle)
      formData.append('CaseRemark', request.CaseRemark)
      formData.append('CaseStatus', request.CaseStatus)

      request.CaseStyles.forEach((caseStyle, index) => {
        formData.append(`CaseStyles[${index}]`, caseStyle)
      })

      request.Blocks.forEach((block, index) => {
        formData.append(`Blocks[${index}].BlockType`, block.BlockType)
        formData.append(`Blocks[${index}].BlockTitle`, block.BlockTitle)

        block.ImageFiles.forEach((imageFile) => {
          formData.append(`Blocks[${index}].ImageFiles`, imageFile)
        })
      })

      return axios
        .post('MntCaseUpload', formData)
        .then((response) => {
          if (response.data.Values) {
            if (response.data.Values.ReqInt === 0) {
              return Promise.resolve('設計分享新增成功！')
            } else {
              return Promise.reject('設計分享新增失敗')
            }
          } else {
            return Promise.reject(response.data.RC)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    ChangeActivityStatus({ commit, rootGetters }, request) {
      return axios
        .post('MntActivityStatus', {
          ActivityGuid: request.ActivityGuid,
          ActivityStatus: request.ActivityStatus
        })
        .then((response) => {
          if (response.data.RC) {
            return Promise.reject(response.data.RC)
          } else if (response.data.Values.ReqInt === 0) {
            return Promise.resolve()
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    MntActivityList({ commit, rootGetters }, request) {
      return axios
        .post('MntActivityList', request)
        .then((response) => {
          if (response.data.RC === '') {
            return Promise.resolve(response.data.Values)
          } else if (response.data.RC === 'Empty Result!') {
            return Promise.resolve([])
          } else {
            return Promise.reject(response.data.RC)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    MntActivityApplyConfirm({ commit, rootGetters }, request) {
      return axios
        .post('MntActivityApplyConfirm', {
          ApplyGuid: request.ApplyGuid,
          ApplyStatus: request.ApplyStatus
        })
        .then((response) => {
          if (response.data.RC) {
            return Promise.reject(response.data.RC)
          } else if (response.data.Values.ReqInt === 0) {
            return Promise.resolve()
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    MntActivityApplyList({ commit, rootGetters }, request) {
      return axios
        .post('MntActivityApplyList', request)
        .then((response) => {
          if (response.data.RC === '') {
            return Promise.resolve(response.data.Values)
          } else if (response.data.RC === 'Empty Result!') {
            return Promise.resolve([])
          } else {
            return Promise.reject(response.data.RC)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    MntActivityApplyForward({ commit, rootGetters }, request) {
      return axios
        .post('MntActivityApplyForward', {
          ApplyGuid: request.ApplyGuid,
          ForwardMail: request.ForwardMail
        })
        .then((response) => {
          if (response.data.RC) {
            return Promise.reject(response.data.RC)
          } else if (response.data.Values.ReqInt === 0) {
            return Promise.resolve()
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    ActivityFile({ commit, rootGetters }, request) {
      return axios
        .post(
          'ActivityFile',
          {
            ActivityFileGuid: request.ActivityFileGuid
          },
          { responseType: 'blob' }
        )
        .then((response) => {
          if (response.data.RC) {
            return Promise.reject(response.data.RC)
          } else if (response.data.Values && response.data.Values.ReqInt === -1) {
            return Promise.reject('發生錯誤')
          } else {
            return Promise.resolve(response.data)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    MntActivityModify({ commit, rootGetters }, request) {
      let formData = new FormData()
      formData.append('ActivityGuid', request.ActivityGuid)
      formData.append('ActivityStart', request.ActivityStart)
      formData.append('ActivityEnd', request.ActivityEnd)
      if (request.ActivityStartTime) {
        formData.append('ActivityStartTime', request.ActivityStartTime)
      }
      if (request.ActivityEndTime) {
        formData.append('ActivityEndTime', request.ActivityEndTime)
      }
      formData.append('ApplyStart', request.ApplyStart)
      formData.append('ApplyEnd', request.ApplyEnd)
      formData.append('ActivityTitle', request.ActivityTitle)
      formData.append('ActivityLocation', request.ActivityLocation)
      formData.append('ActivityApplyType', request.ActivityApplyType)
      formData.append('ActivityDescrib', request.ActivityDescrib)
      formData.append('ActivityRemark', request.ActivityRemark)
      formData.append('ActivityAgenda', request.ActivityAgenda)
      formData.append('ActivityContact', request.ActivityContact)
      request.ActivityAddImages.forEach((image, index) => {
        formData.append(`ActivityImages[${index}].ImageName`, '')
        formData.append(`ActivityImages[${index}].Image`, image)
      })

      request.ActivityAddAttachs.forEach((attach, index) => {
        formData.append(`ActivityAttachs[${index}].AttachName`, '')
        formData.append(`ActivityAttachs[${index}].Attach`, attach)
      })

      request.ActivityRemoveImages.forEach((removeImage, index) => {
        formData.append(`RemoveActivityImages[${index}]`, removeImage)
      })

      request.ActivityRemoveAttachs.forEach((removeAttach, index) => {
        formData.append(`RemoveActivityAttachs[${index}]`, removeAttach)
      })

      return axios
        .post('MntActivityModify', formData)
        .then((response) => {
          if (response.data.RC) {
            return Promise.reject(response.data.RC)
          } else if (response.data.Values.ReqInt === 0) {
            return Promise.resolve()
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    MntActivityRead({ commit, rootGetters }, request) {
      return axios
        .post('MntActivityRead', {
          ActivityGuid: request.ActivityGuid
        })
        .then((response) => {
          if (response.data.RC === '') {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.RC)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    MntActivityApplyDetail({ commit, rootGetters }, request) {
      return axios
        .post('MntActivityApplyDetail', {
          ApplyGuid: request.ApplyGuid
        })
        .then((response) => {
          if (response.data.RC === '') {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.RC)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    }
  }
}
